<template>
  <h1>Einstellungen</h1>

  <div v-if="!store.getters.isAdmin" class="alert alert-danger my-4">
    Sie haben keine Berechtigungen auf dieser Seite. Bitte wenden Sie sich an einen Administrator.
  </div>

  <DatabaseStatus v-if="store.getters.isAdmin" />

  <Benutzer v-if="store.getters.isAdmin" />

  <QRCodeTrennzeichen v-if="store.getters.isAdmin" />
</template>

<script lang="ts" setup>
  //#region Imports
  import { useStore } from '@/store';

  import DatabaseStatus from '@/components/Einstellungen/DatabaseStatus.vue';
  import Benutzer from '@/components/Einstellungen/Benutzer.vue';
  import QRCodeTrennzeichen from '@/components/Einstellungen/QRCodeTrennzeichen.vue';
  //#endregion

  const store = useStore();
</script>
